
import React, { Component } from 'react';
import { connect } from 'react-redux'

import LoginComponent from '../../components/login/loginComponent.js'
import CdnImage from '../../components/cdnImage/cdnImage.js'

var stateManager = require('../../utils/state/stateManager.js');
var staffLoginAction = require('../../utils/state/actions/staffLogin/staffLoginAction.js');
var StaffLoginData = require('../../utils/state/actions/staffLogin/staffLoginData.js');

var localizationUtils = require('../../utils/domain/localizationUtils');
var themeUtil = require('../../utils/view/themeUtil.js');
var configurationManager = require('../../utils/config/configurationManager.js');
var translator = require('../../utils/translator/translator');
var beamerUtils = require('../../utils/beamer/beamerUtils.js');



class LoginView extends Component 
{
    constructor(props) 
    {
        super(props);
        this.onLogin = this.onLogin.bind(this);
    }
    render() 
    {
        var cloudName = configurationManager.getConfig().cdnAppCloudName;

        return (
            <div className="app flex-row align-items-center" style={{width:'100%', height:'100%', margin:'0px'}}>
                <div style={{position:'fixed', top:'50%', left:'50%', transform:'translate(-50%, -50%)'}}>
                    <table>
                            <tr>
                                <td align="center">
                                    <div className='pb-1'>
                                        <CdnImage cloudName={cloudName} height={Math.round(window.innerHeight * 0.2)} publicId={themeUtil.getResolvedLogo()}/>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td align="center">
                                    <div className='caption primary-color'>
                                        {translator.getLabel("please_enter_your_pin")}
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td align="center">
                                    <LoginComponent pinAllowed={true} onLogin={this.onLogin} staffs={this.props.staffs}/>
                                </td>
                            </tr>

                            <tr>
                                <td align="center">
                                    <div  className="primary-color d-flex flex-row justify-content-center align-items-center" style={{textAlign:'center', whiteSpace:'nowrap', marginTop: '20px', marginBottom:'10px'}}>
                                        
                                        <div className="mr-1 make-child-img-full-width" style={{width:"1.3rem", height:'1.7rem'}}>
                                            <CdnImage cloudName={cloudName} width='0.05' publicId={themeUtil.getPublicId('whatsapp.png')}/>
                                        </div>
                                        <div style={{marginLeft: '8px'}}>
                                            {translator.getLabel("whatsapp_support")}: {localizationUtils.getSupportWhatsAppNumber()}
                                        </div>
                                        
                                        <div className="mr-1 make-child-img-full-width" style={{marginLeft:'60px', width:"1.3rem", height:'1.7rem'}}>
                                            <CdnImage cloudName={cloudName} width='0.05' publicId={themeUtil.getPublicId('email.png')}/>
                                        </div>
                                        <div style={{marginLeft: '8px'}}>
                                            {translator.getLabel("email_support")}: {localizationUtils.getSupportEmailAddress()}
                                        </div>

                                        <div className="mr-1 make-child-img-full-width" style={{marginLeft:'60px', width:"1.3rem", height:'1.7rem' }}>
                                            <CdnImage cloudName={cloudName} width='0.05' publicId={themeUtil.getPublicId('phone.png')}/>
                                        </div>
                                        <div style={{marginLeft: '8px'}}>
                                            {translator.getLabel("phone_support")}: {localizationUtils.getSupportPhoneNumber()}
                                        </div>

                                    </div>
                                </td>
                            </tr>
                        </table>
                </div>
            </div>
        );
    }


    onLogin(isPin, staff)
    {
        beamerUtils.updateBeamer(staff);

        var staffLoginData = new StaffLoginData();
        staffLoginData.staff = staff;
        staffLoginData.loginViaPin = isPin;
        stateManager.getStore().dispatch(staffLoginAction.createAction(staffLoginData));
    }
}

const mapStateToProps = state => 
{
    return { 
              property: state.orgData.property,
              franchisor: state.orgData.franchisor,
              staffs: state.staffs
          }
}

export default connect(mapStateToProps)(LoginView)
